import React from "react";
import { Modal, Box, Typography, Grid } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import styled from "styled-components";

const PreviewModal = ({ previews, mailData, setMailData }) => {
  return (
    <Modal
      open={mailData.showPreviews}
      onClose={() => setMailData({ ...mailData, showPreviews: false })}
    >
      <StyledBox>
        <StyledGrid container alignItems="center">
          <Grid item>
            <Typography variant="h4">Preview</Typography>
          </Grid>
          <Grid item style={{ flex: "1" }}></Grid>
          <Grid item>
            <CloseIcon
              onClick={() => setMailData({ ...mailData, showPreviews: false })}
              style={{ color: "white" }}
            />
          </Grid>
        </StyledGrid>
        <Grid container>
          {previews.map((el) => {
            return (
              <StyledGrid1 container direction="column">
                <Grid item>
                  From : {el.from_name} {"<"} {el.from} {">"}
                </Grid>
                <Grid item>To : {el.to}</Grid>
                <Grid item>Subject : {el.subject}</Grid>
                <Grid item>Body :</Grid>
                <Grid item>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: el.html,
                    }}
                  ></div>
                </Grid>
              </StyledGrid1>
            );
          })}
        </Grid>
      </StyledBox>
    </Modal>
  );
};

export default PreviewModal;

const StyledBox = styled(Box)`
  && {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    max-height: 90vh;
    overflow: auto;
    min-width: 500px;
    max-width: 90vw;
    boxshadow: 0.5px 1px 25px 0.5px rgba(0, 0, 0, 0.3);
  }
`;

const StyledGrid = styled(Grid)`
  && {
    padding: 10px 10px 10px 10px;
    background-color: #404040;
    color: white;
  }
`;

const StyledGrid1 = styled(Grid)`
  && {
    padding: 5px;
    margin: 5px;
    border: 1px solid gray;
  }
`;